import Logo from './Logo';
import Shows from './Shows';

export default function ShowsHeader() {
  return (
    <div className="shows">
      <Logo />
      <Shows />
    </div>
  )
}